export const MIGRATION_STATUS = {
  VALIDATION_FAILED: 'ValidationFailed',
  VALIDATION_COMPLETED: 'ValidationCompleted',
  COMPLETED: 'Completed',
  MIGRATION_PARTIAL_SUCCESS: 'MigrationPartialSuccess',
  MIGRATION_FAILED: 'MigrationFailed',
  DUPLICATE_CONF: 'DuplicateConfiguration',
  IMPORT_FAILED: 'ImportFailed',
  INPROGRESS: 'InProgress',
  VALIDATING: 'Validating'
};
export const API_STATUS_INFO = {
  UNAUTHORIZED: 'UNAUTHORIZED'
};
export const NO_FILE_CHOSEN = 'No file chosen';
export const HOST_NAMES = {
  DEV_HOST: 'asset360tooling-dev',
  LOCAL_HOST: 'localhost',
  BLUE_HOST: 'asset360tooling-validation'
};
export const ENV_TYPES = {
  SANDBOX: 'sandbox',
  PRODUCTION: 'production'
};
export const ORG_TYPES = {
  SOURCE: 'source',
  TARGET: 'target'
};

// date time formats
export const DEFAULT_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:MM:SS';
export const DEFAULT_TIME_ZONE = 'America/Los_Angeles';
export const DEFAULT_USER_LOCALE = 'en-US';
export const SOURCE_LOGIN_CARD_NUMBER = '1';
export const TARGET_LOGIN_CARD_NUMBER = '2';
export const BUTTONS_IDS = {
  VALIDATE_ID: 'validate-button',
  DEPLOY_ID: 'deploy-button'
};
export const ORG_USER_INFO = {
  USER: 'User',
  ORG: 'Org',
  ORG_TYPE: 'Org Type',
  ORG_NAME: 'Org Name'
};
export const FILTER_OPTIONS = {
  CONFIGURATION_NAME: 'Configuration Name',
  DEVELOPER_NAME: 'Developer Name',
  TYPE: 'Type',
  SUB_TYPE: 'Sub Type'
};

// Object and field's names
export const MODIFIED_ON = 'modifiedOn';
export const DEPLOYED_TIME = 'deployedTime';

//Success and failure messages

export const VALIDATION_COMPLETE = 'Validation Complete';
export const VALIDATION_FAILURE = 'One or more items have failed validation and will not be deployed. ';
export const VALIDATION_ISSUES = 'Validation issues';
export const DEPLOYMENT_ISSUES = 'Deployment issues';
export const ITEMS_NOT_DEPLOY = 'These items will not be deployed to the destination org';
export const ITEMS_DEPLOYED = ' items were deployed';
export const DEPLOY_FAILURE = 'One or more items could not be deployed. ';
export const MORE_INFO = 'More Information';
export const DEPLOYMENT_ERROR = 'Deployment Errors';
export const DEPLOY_COMPLETE = ' items were deployed';
export const INTERNAL_SERVER_ERROR = 'Internal server error';
export const INVALID_CONFIG_MSG = 'There are no valid configurations in the uploaded file';
export const LOGOUT_MESSAGES = {
  HEADER: 'Disconnect Source?',
  MESSAGE: 'If you disconnect the Source Org you will also be signed out of the Target Org and any selections you have made will be cleared.',
  CONFIRM_MESSAGE: 'Are you sure you want to disconnect the Source Org?',
  UPLOAD_FILE_HEADER: 'Disconnect Target?',
  UPLOAD_FILE_MESSAGE: 'Due to current action you will be signed out from the Target Org. Do you want to proceed?'
};
export const VALIDATION_NOT_REQUIRED = 'Validation not required';
export const WARNING = 'Warning';
export const TAB_TITLES = {
  CONFIGURED_ELEMENTS: 'Configured Elements',
  TRANSLATIONS: 'Translations'
};
export const NONE_OPTION = '--None--';